import Modal from "@/common/elements/Modal";
import BookingQueueDetailForm from "./BookingQueueDetailForm";
import { useEffect, useRef, useState } from "react";
import { hasCheckSecurity } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const BookingQueueDetailsModal = ({
  show,
  onHide,
  stepData,
  onSave,
  bookings,
  isEditing = false,
  startingPoint,
}) => {
  const formRef = useRef();
let user=JSON.parse(localStorage.getItem("userDetails"))
  const onSaveClick = async () => {
    const values = await formRef.current.getFieldsValue();
    const creatorStaffID = user?.staffId;

    // handleSave returns false to block the save (e.g. an incomplete
    // prerequisite step) — keep the modal open so the user can see why.
    const saved = onSave({ ...values, creatorStaffID });
    if (saved !== false) {
      onHide();
    }
  };

  const [isDisabled, setIsDisabled] = useState(false);
  useEffect(() => {
    if (isEditing) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEditing]);
  return (
    <Modal
      header="Booking Queue Details"
      show={show}
      onHide={onHide}
      size="xl"
      footerActions={[
        {
          key: "save",
          text: "Save",
          onClick: onSaveClick,
          disabled: isDisabled,
        },
      ]}
      footerCloseAction={() => setIsDisabled(false)}
      footerCloseActionText="Close"
    >
      <BookingQueueDetailForm
        ref={formRef}
        stepData={stepData}
        bookings={bookings}
        isEditing={isEditing}
        existingSteps={bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.map(
          (item) => item.queStepID
        )}
        onCloseModal={onHide}
        startingPoint={startingPoint}
      />
    </Modal>
  );
};

export default BookingQueueDetailsModal;
